<template>
	<div>
		<div class="ks-videoeditor-inspector-title">Position</div>
		<div class="ks-videoeditor-inline">
			<k-btn v-for="p in presets" :key="p.name" size="s" icon :icon-name="p.icon" :title="p.name == 'full' ? full_title : p.title" @click="$emit('preset', p.name)"></k-btn>
		</div>
		<div class="ks-videoeditor-inline">
			<k-text-field label="X (%)" type="number" :value="round(item.x)" @input="set('x', $event, -100, 100)"></k-text-field>
			<k-text-field label="Y (%)" type="number" :value="round(item.y)" @input="set('y', $event, -100, 100)"></k-text-field>
		</div>
		<k-text-field label="Width (% of frame)" type="number" :value="round(item.w)" @input="set('w', $event, 5, 200)"></k-text-field>
	</div>
</template>

<script>
import {round} from './utils.js'

// Preset buttons and x/y/width fields of an item's frame in the preview
export default {
	props: {
		item: Object,
		full_title: {type: String, default: "Fit to frame"}
	},
	data () {
		return {
			presets: [
				{name: "full", icon: "fullscreen"},
				{name: "top-left", icon: "north_west", title: "Top left"},
				{name: "top-right", icon: "north_east", title: "Top right"},
				{name: "bottom-left", icon: "south_west", title: "Bottom left"},
				{name: "bottom-right", icon: "south_east", title: "Bottom right"},
				{name: "center", icon: "filter_center_focus", title: "Center"}
			]
		}
	},
	methods: {
		round,
		set (key, value, min, max) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.$emit("change", {[key]: _.clamp(v, min, max), placed: true});
		}
	}
}
</script>
